import Loader from '@preqin/ui-components/cjs/core/Loader';

import styles from './oidc.module.scss';

const AuthError = () => (
  <div className={styles.oidcComponentWrapper}>
    <Loader
      isLoading={false}
      showError={true}
      showErrorButton={true}
      hideErrorMessage={false}
      onError={() => console.log('Authentication Error.')}
      onErrorButtonClick={() => window.location.reload()}
      errorButtonText={'Reload'}
    />
  </div>
);

export default AuthError;
